import axios from './index.js'

let user_service = {
  query: info => {
    return axios({
      method: 'get',
      url: 'api/userinfo',
      params: info
    })
  },

  // 获得验证码
  getCode() {
    return axios({
      method: 'get',
      url: 'api/rest/code/getCode',
      responseType: 'blob'
    })
  },

  // 登录接口
  login(info) {
    return axios({
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'post',
      data: info,
      url: '/rest/login'
    })
  },
  // 注销
  logOut(){
    return axios({
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'post',
      url: '/rest/logout'
    })
  },

  //是否登录
  isLogin(){
    return axios({
      method: 'get',
      url: 'api/rest/isLogin',
    })
  },
  
  // 操作日志
  logs(info) {
    return axios({
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'post',
      data: info,
      url: 'api/rest/log/getOperateLogList'
    })
  }
}
export default user_service
